<template>
	<div id="app" class="bc-t-333 bc-f-14rp">

		<bv-view-transition id="runapptop" v-if="$route.meta.useKeepAlive && $route.meta.useKeepAlive == 'false'">
			<router-view/>
		</bv-view-transition>

		<!--需要缓存的页面-->
		<bv-view-transition id="runappbottom" v-else>
			<keep-alive :exclude="config.view.keepAlive.exclude">
				<router-view/>
			</keep-alive>
		</bv-view-transition>
		<!-- 全局分享按钮 -->
		<template v-if="!config.device.isApp">
			<div id="shareBox" @click="clickShare()" v-show="isShare"></div>
		</template>
		<div id="tips-mask" v-show="isShow" @click="isShow = false">
			<img id="tips-mask-item" width="70%" height="48%" :src="`${programUrl['gou-wu-bao']}/Static/spa/img/home/angel/Tips.png`" alt="慧联天下|大健康|首页">
			<img id="tips-mask-item" width="70%" height="15%" :src="`${programUrl['gou-wu-bao']}/Static/spa/img/home/angel/Tips2.png`" alt="慧联天下|大健康|首页">
		</div>
		<!-- 底部导航 -->
		<w-tab-bar></w-tab-bar>

		<!-- 图片预览的组件 -->
		<blue-photo-swipe></blue-photo-swipe>

	</div>
</template>

<script>
  import programUrl from "@config/program-url";
  import './assets/js/shareBox.js';
  import {login} from "$assets/js/login";

  export default {
    name: 'app',
	data() {
		return {
			programUrl: programUrl,
			isShow: false,
			isShare: true,
		}
	},
	watch:{
		'$route.path': {
			// 监听全局的计时器
			handler: function(newPath, oldPath){
				if(String(newPath).includes('/member/') || newPath.indexOf('apply') != -1 || newPath.indexOf('/location') != -1) {
					this.isShare = false;
				} else {
					this.isShare = true;
				}
			}
		}
	},
	methods: {
			// 点击分享按钮
			clickShare() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					// 判断是否是公众号
					this.isShow = true;
				} else if(this.config.device.isApp) {
					// 判断是否是APP
					var ele = document.getElementsByClassName('appshare')[0];
					// 判断是否登录
					if(!this.$store.getters.isLogin) {
						login();
						return false;
					} else {
						if(ele) {
							ele.click();
						} else {
							// 没有分享按钮使用默认分享
							this.$share({});
						}
					}
				} else {
					this.$toast('请使用浏览器自带分享');
				}
			}
		}
  };
</script>

<style lang="scss">
	/*阿里字体图标*/
	@import url("//at.alicdn.com/t/font_1131863_0tq5ryy83j2k.css");
	/*阿里字体图标*/ //2021-10-30驾校复制
	@import url("//at.alicdn.com/t/font_1522064_1y57zee6q6s.css");

	html,
	body {
		width: 100%;
		height: 100%;
	}

	#shareBox {
		width: 40px;
		height: 40px;
		background: url($base-static-path + "/img/home/angel/app_shart.png") no-repeat;
  		background-size: 100% 100%;
		position: absolute;
		top: 60%;
		right: 2%;
		z-index: 1000;
	}
	#tips-mask {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 1001;
	}
	#tips-mask-item {
		float: right;
	}
</style>
